module.exports = __webpack_public_path__ + "img/NLF0001.41509ce1.svg";